module.exports = __webpack_public_path__ + "img/airtime.ffabad1a.jpeg";